var Request = require("../../helper/request");

function InviteAction(app, companyId, inviteId){
	var self = this;
	self.companyId = companyId;
	self.inviteId = inviteId;
	self.request = new Request(app);

	self.routes = {
		index: {
			url: "/company/"+self.companyId+"/invite/"+ self.inviteId +"/action",
			method: "GET"
		},
		create: {
			url: "/company/"+self.companyId+"/invite/"+ self.inviteId +"/action",
			method: "POST"
		},
		delete: {
			url: "/company/"+self.companyId+"/invite/"+ self.inviteId + "/action/:id",
			method: "DELETE"
		}
	};
}

InviteAction.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

InviteAction.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		action: data
	});
}

InviteAction.prototype.delete = function(id){
	var self = this;
	var uri = self.routes.delete.url.replace(":id", id);
	return self.request.delete(uri);
}

module.exports = InviteAction;